import { Col, Container, Row } from "reactstrap";

import WidgetsGrid from "./gridCards"; //Grid Cards
import BarChart from './barChart' //Bar chart
import Project from "./projectList"; //Project List
import BandWidth from "./bandwidth";
const Analytics = () => {
   return (
    <Container className="pt-3">
      <Row>
        <Col>
          <BarChart />
        </Col>
        <Col>
          <WidgetsGrid />
        </Col>
      </Row>

      <Row className="mt-4">
        <Col>
          <Project />
        </Col>
      </Row>
    </Container>
  );
}
export default Analytics